import axios from 'axios';
import React from 'react';
import Joyride from 'react-joyride';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { descobrirContrato } from '../../actions/ContratoActions';
import { obterItensTipoFTab } from '../../actions/ItemActions';
import { enviarEmail } from '../../actions/EmailActions';
import { obterFormandosPeloContrato } from '../../actions/FormandoActions';
import { URL_PAGAMENTO } from '../../config/urls';
import TelegramService from '../../services/TelegramService';
import {
  GaleriaProduto,
  MiniaturaProduto,
} from '../../components/GaleriaProduto';
import './styles.css';

/** Seta do acordeao de descricao. */
const IconeSetinha = ({ aberta }) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.6'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    style={{ display: 'block' }}
  >
    {aberta ? <path d='M5 15l7-7 7 7' /> : <path d='M5 9l7 7 7-7' />}
  </svg>
);

/** Carrinho de compras (icone solido, desenho classico). */
const IconeCarrinho = ({ tamanho = 16 }) => (
  <svg
    className='pf-icone-carrinho'
    width={tamanho}
    height={tamanho}
    viewBox='0 0 24 24'
    fill='currentColor'
    aria-hidden='true'
    focusable='false'
  >
    <path d='M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' />
  </svg>
);

class Contrato extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pedidos: [],
      carregandoPedidos: true,
      erroPedidos: false,
      run: false,
      produtoNaGaleria: null,
      detalheAberto: null,
    };
  }

  componentWillMount() {
    if (localStorage.getItem('tutorialContrato') === null) {
      this.setState({ run: true });
      localStorage.setItem('tutorialContrato', true);
    }

    this.props
      .descobrirContrato(
        this.props.usuario.tipo,
        this.usuarioEhFormando()
          ? this.props.numeroContrato
          : this.props.usuario.id
      )
      .catch(() => {
        this.setState({ carregandoPedidos: false, erroPedidos: true });
      });
  }

  componentDidMount() {
    this.sincronizarDados();
  }

  componentDidUpdate() {
    this.sincronizarDados();
  }

  /**
   * A action do contrato nao devolve os dados carregados, entao a busca dos
   * pedidos e do catalogo espera o contrato aparecer nas props (o menu tambem
   * carrega o contrato, entao ele pode chegar antes desta tela montar).
   */
  sincronizarDados() {
    const contratoId = this.props.contrato && this.props.contrato.id;

    if (!contratoId || this.contratoSincronizado === contratoId) return;
    this.contratoSincronizado = contratoId;

    this.props.obterFormandosPeloContrato(contratoId);
    this.carregarPedidos();

    if (this.podeComprar()) {
      this.props.obterItensTipoFTab(contratoId, [
        'avulso',
        'kit',
        'itemFuturo',
      ]);
    }
  }

  /* ------------------------------------------------------------------ dados */

  usuarioEhFormando() {
    return this.props.usuario.tipo === 'formando';
  }

  podeComprar() {
    return this.usuarioEhFormando() && this.props.contrato.sistemaPagto === 1;
  }

  carregarPedidos() {
    if (!this.podeComprar()) {
      this.setState({ carregandoPedidos: false });
      return;
    }

    const tokenPagamento = sessionStorage.getItem('tokenPagamento');

    if (!tokenPagamento) {
      this.setState({ carregandoPedidos: false, erroPedidos: true });
      return;
    }

    axios
      .get(`${URL_PAGAMENTO}/formando/pedidos`, {
        headers: { Authorization: 'Bearer ' + tokenPagamento },
      })
      .then((response) => {
        this.setState({
          pedidos: Array.isArray(response.data) ? response.data : [],
          carregandoPedidos: false,
        });
      })
      .catch((erro) => {
        this.setState({ carregandoPedidos: false, erroPedidos: true });
        new TelegramService().novo('ERROR', [
          JSON.stringify(erro),
          'Pegar os pedidos do formando - tela inicial',
          `usuarioLogado: ${sessionStorage.getItem('usuarioLogadoComissao')}`,
        ]);
      });
  }

  /** Consolida os pedidos do formando em indicadores e em uma lista de itens. */
  resumoDasCompras() {
    let valorTotal = 0,
      valorPago = 0,
      quantidadeItens = 0,
      quantidadePedidos = 0;
    const mapaItens = {};

    this.state.pedidos.forEach((pedido) => {
      if (pedido.status === 'Pedido cancelado') return;

      quantidadePedidos += 1;

      const cobranca = pedido.cobranca || {};
      valorTotal += Number(cobranca.valor) || 0;
      valorPago += Number(cobranca.valorJaPago) || 0;

      (pedido.itens || []).forEach((item) => {
        const nome = item.nome || item.produto || 'Item';
        const quantidade = Number(item.quantidade) || 0;
        const valor = Number(item.valor != null ? item.valor : item.total) || 0;

        quantidadeItens += quantidade;

        if (!mapaItens[nome]) {
          mapaItens[nome] = { nome, quantidade: 0, valor: 0 };
        }
        mapaItens[nome].quantidade += quantidade;
        mapaItens[nome].valor += valor;
      });
    });

    return {
      itens: Object.keys(mapaItens)
        .map((nome) => mapaItens[nome])
        .sort((a, b) => a.valor - b.valor),
      valorTotal,
      valorPago,
      valorPendente: Math.max(valorTotal - valorPago, 0),
      quantidadeItens,
      quantidadePedidos,
    };
  }

  /** Itens contratados (visao da comissao). */
  resumoDoContrato() {
    const itensContrato = this.props.contrato.itens || [];
    let valorTotal = 0,
      quantidadeItens = 0;

    const itens = itensContrato.map((item) => {
      const quantidade = Number(item.quantidade) || 0;
      const valor = quantidade * (Number(item.preco) || 0);

      valorTotal += valor;
      quantidadeItens += quantidade;

      return { nome: item.produto || item.nome || 'Item', quantidade, valor };
    });

    return { itens, valorTotal, quantidadeItens };
  }

  /**
   * Catalogo do formando: usa a lista de distribuiveis quando ela chega e,
   * enquanto isso, os itens que ja vem junto com o contrato. Filtra por
   * exclusao (fora brindes) para nao depender do preenchimento de categoria.
   */
  catalogoDeProdutos() {
    const distribuiveis = this.props.itensDisponiveis || [];
    const doContrato = this.props.contrato.itens || [];
    const catalogo = distribuiveis.length > 0 ? distribuiveis : doContrato;

    return catalogo.filter(
      (item) => item.observacao !== 'brinde' && item.tipo !== 'P'
    );
  }

  /**
   * Produtos que o formando ainda nao comprou. O que ja foi adquirido vem dos
   * pedidos (API de pagamento) - o campo `formando.itens` nao serve aqui,
   * porque representa a distribuicao de itens do contrato, nao a compra.
   */
  produtosDisponiveis() {
    const catalogo = this.catalogoDeProdutos();
    if (catalogo.length === 0) return [];

    const comprados = {};
    this.resumoDasCompras().itens.forEach((item) => {
      comprados[this.chaveProduto(item.nome)] = true;
    });

    return catalogo
      .filter((item) => !comprados[this.chaveProduto(item.produto)])
      .map((item) => ({
        id: item.id,
        nome: item.produto,
        fotos: item.fotos,
        preco:
          Number(
            item.observacao === 'itemFuturo' ? item.valorAdendo : item.preco
          ) || 0,
      }))
      .filter((item) => item.preco > 0)
      .sort((a, b) => a.preco - b.preco);
  }

  /** Fotos cadastradas para um produto, procurando no catalogo pelo nome. */
  produtoDoCatalogo(nome) {
    const chave = this.chaveProduto(nome);

    return this.catalogoDeProdutos().filter(
      (item) => this.chaveProduto(item.produto) === chave
    )[0];
  }

  /**
   * Quebra a descricao em topicos. No cadastro, os blocos vem separados por
   * "," (quando o kit junta varios produtos) e por "/" (partes do mesmo
   * produto); dentro de cada bloco, "+" lista os acabamentos.
   */
  topicosDaDescricao(texto) {
    if (!texto) return [];

    return String(texto)
      .replace(/[;,\s]+$/, '')
      .split(/[,/]/)
      .map((bloco) => bloco.trim())
      .filter((bloco) => bloco.length > 0)
      .map((bloco) => {
        const partes = bloco
          .split('+')
          .map((parte) => parte.trim())
          .filter((parte) => parte.length > 0);

        return { titulo: partes[0], detalhes: partes.slice(1) };
      });
  }

  /** Composicao do kit ("1 Convite;2 Encartes" -> lista). */
  topicosDaComposicao(texto) {
    if (!texto) return [];

    return String(texto)
      .replace(/[;\s]+$/, '')
      .split(';')
      .map((parte) => parte.trim())
      .filter((parte) => parte.length > 0);
  }

  detalhesDoProduto(nome) {
    const doCatalogo = this.produtoDoCatalogo(nome) || {};

    return {
      composicao: this.topicosDaComposicao(doCatalogo.itens),
      descricao: this.topicosDaDescricao(doCatalogo.descricao),
    };
  }

  alternarDetalhe(chave) {
    this.setState({
      detalheAberto: this.state.detalheAberto === chave ? null : chave,
    });
  }

  renderBotaoDetalhe(chave) {
    const aberto = this.state.detalheAberto === chave;

    return (
      <button
        type='button'
        className={aberto ? 'pf-btn-detalhe aberto' : 'pf-btn-detalhe'}
        onClick={() => this.alternarDetalhe(chave)}
        title={aberto ? 'Ocultar descrição' : 'Ver descrição'}
      >
        <IconeSetinha aberta={aberto} />
      </button>
    );
  }

  renderDetalhes(nome) {
    const { composicao, descricao } = this.detalhesDoProduto(nome);

    return (
      <div className='pf-detalhes'>
        {composicao.length > 0 ? (
          <div className='pf-detalhes-bloco'>
            <div className='pf-detalhes-titulo'>O que vem no produto</div>
            <ul className='pf-topicos'>
              {composicao.map((parte, indice) => (
                <li key={indice}>{parte}</li>
              ))}
            </ul>
          </div>
        ) : null}

        {composicao.length === 0 && descricao.length === 0 ? (
          <div className='pf-detalhes-vazio'>
            Sem descrição cadastrada para este produto.
          </div>
        ) : null}

        {descricao.length > 0 ? (
          <div className='pf-detalhes-bloco'>
            <div className='pf-detalhes-titulo'>Especificações</div>
            <ul className='pf-topicos'>
              {descricao.map((topico, indice) => (
                <li key={indice}>
                  {topico.titulo}
                  {topico.detalhes.length > 0 ? (
                    <ul>
                      {topico.detalhes.map((detalhe, posicao) => (
                        <li key={posicao}>{detalhe}</li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    );
  }

  categoriaDoProduto(nome) {
    const doCatalogo = this.produtoDoCatalogo(nome) || {};
    const categoria = (doCatalogo.categoria || '').toString().trim();

    return categoria.length > 0 ? categoria : '-';
  }

  abrirGaleria(nome) {
    const doCatalogo = this.produtoDoCatalogo(nome);

    this.setState({
      produtoNaGaleria: {
        nome,
        fotos: doCatalogo ? doCatalogo.fotos : null,
      },
    });
  }

  fecharGaleria() {
    this.setState({ produtoNaGaleria: null });
  }

  chaveProduto(nome) {
    return (nome || '').toString().trim().toLowerCase();
  }

  /* ---------------------------------------------------------------- helpers */

  formatarMoeda(valor) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(Number(valor) || 0);
  }

  /** R$ alinhado a esquerda e o numero a direita, para as linhas baterem. */
  renderValor(valor) {
    const numero = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(valor) || 0);

    return (
      <span className='pf-moeda'>
        <span className='pf-moeda-simbolo'>R$</span>
        <span className='pf-moeda-numero'>{numero}</span>
      </span>
    );
  }

  formatarData(data) {
    if (!data) return '--';
    const convertida = new Date(data);
    if (isNaN(convertida.getTime())) return '--';
    return convertida.toLocaleDateString('pt-BR');
  }

  primeiroNome() {
    const nome = (this.props.usuario && this.props.usuario.nome) || '';
    if (!nome) return 'Formando(a)';

    const base = nome.indexOf('@') > -1 ? nome.split('@')[0] : nome;
    const primeiro = base.trim().split(' ')[0] || base;

    return primeiro.charAt(0).toUpperCase() + primeiro.slice(1).toLowerCase();
  }

  passosTutorial() {
    const passos = [
      {
        content: (
          <div>
            <h3>Bem-vindo(a) ao seu portal!</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Aqui você acompanha as informações do seu contrato de formatura.
            </span>
          </div>
        ),
        placement: 'center',
        target: '#divContent',
        disableBeacon: true,
      },
      {
        content: (
          <div>
            <h3>Informações do contrato</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Número do contrato, gestor(a) responsável e data de início ficam
              sempre à mão.
            </span>
          </div>
        ),
        placement: 'bottom',
        target: '#dadosGerais',
      },
    ];

    if (this.podeComprar()) {
      passos.push({
        content: (
          <div>
            <h3>Suas compras</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Veja os itens que você já adquiriu e compre mais quando quiser.
            </span>
          </div>
        ),
        placement: 'top',
        target: '#painelCompras',
      });
    }

    return passos;
  }

  /* ---------------------------------------------------------------- blocos  */

  renderCabecalho() {
    const { contrato } = this.props;
    const gestor = (contrato.dono && contrato.dono.nome) || 'Não definido';

    return (
      <section className='pf-head' id='divContent'>
        <div className='pf-head-main'>
          <span className='pf-eyebrow'>Portal do formando</span>

          <h1 className='pf-hello'>Olá, {this.primeiroNome()}!</h1>

          <p className='pf-lead'>
            Seja bem-vindo(a) e obrigado por escolher a{' '}
            <strong>Alpha Convites</strong>. Este é o seu portal exclusivo.
          </p>
        </div>

        <div className='pf-meta' id='dadosGerais'>
          <div className='pf-meta-item'>
            <div className='pf-meta-label'>Contrato</div>
            <div className='pf-meta-value is-strong'>
              {contrato.numero || '--'}
            </div>
          </div>

          <div className='pf-meta-item'>
            <div className='pf-meta-label'>Gestor(a)</div>
            <div className='pf-meta-value'>{gestor}</div>
          </div>

          <div className='pf-meta-item'>
            <div className='pf-meta-label'>Data de início</div>
            <div className='pf-meta-value'>
              {this.formatarData(contrato.dataInicio)}
            </div>
          </div>

          <div className='pf-meta-item'>
            <div className='pf-meta-label'>E-mail principal</div>
            <div className='pf-meta-value'>
              {contrato.emailComissao || '--'}
            </div>
          </div>
        </div>
      </section>
    );
  }

  renderCarregando() {
    return (
      <div className='pf-skeleton pf-skeleton-card' />
    );
  }

  renderTabelaItens(resumo, titulo, rotuloTotal, comAcao) {
    const { itens } = resumo;
    const classeLinha = comAcao ? 'pf-tr pf-tr-acao' : 'pf-tr';

    return (
      <div className={comAcao ? 'pf-card pf-card-destaque' : 'pf-card'}>
        <div className='pf-card-head'>
          <h3 className='pf-card-title'>{titulo}</h3>
          <span className='pf-card-note'>
            {itens.length === 1 ? '1 produto' : `${itens.length} produtos`}
          </span>
        </div>

        <div className={`${classeLinha} pf-thead`}>
          <div>Item</div>
          <div className='pf-cell-categoria'>Categoria</div>
          <div className='pf-cell-qty'>Quantidade</div>
          <div className='pf-cell-value'>Valor</div>
          {comAcao ? <div /> : null}
        </div>

        <div className='pf-tbody'>
          {itens.map((item, indice) => {
            const chave = `adquirido-${item.nome}-${indice}`;
            return (
            <div className='pf-linha' key={chave}>
            <div className={classeLinha}>
              <div className='pf-item'>
                <MiniaturaProduto
                  produto={{
                    nome: item.nome,
                    fotos: (this.produtoDoCatalogo(item.nome) || {}).fotos,
                  }}
                  tamanho={58}
                  onClick={() => this.abrirGaleria(item.nome)}
                />
                <div className='pf-item-label'>{item.nome}</div>
                {this.renderBotaoDetalhe(chave)}
              </div>

              <div className='pf-cell-categoria'>
                <div className='pf-cell-label'>Categoria</div>
                {this.categoriaDoProduto(item.nome)}
              </div>

              <div className='pf-cell-qty'>
                <div className='pf-cell-label'>Quantidade</div>
                {item.quantidade}
              </div>

              <div className='pf-cell-value'>
                <div className='pf-cell-label'>Valor</div>
                {this.renderValor(item.valor)}
              </div>

              {comAcao ? (
                <div className='pf-cell-action'>
                  <Link to='/comprar' className='pf-btn-row'>
                    <IconeCarrinho tamanho={16} /> Comprar mais
                  </Link>
                </div>
              ) : null}
            </div>

            {this.state.detalheAberto === chave
              ? this.renderDetalhes(item.nome)
              : null}
            </div>
            );
          })}
        </div>

        {comAcao ? null : (
          <div className={`${classeLinha} pf-tfoot`}>
            <span className='pf-tfoot-label'>{rotuloTotal}</span>
            <span />
            <span className='pf-tfoot-qty'>{resumo.quantidadeItens}</span>
            <span className='pf-tfoot-value'>
              {this.renderValor(resumo.valorTotal)}
            </span>
          </div>
        )}
      </div>
    );
  }

  renderEstadoVazio() {
    return (
      <div className='pf-vazio'>
        <p className='pf-vazio-texto'>
          Você ainda não realizou nenhuma compra. Escolha um dos produtos
          acima, defina a quantidade e finalize o pedido com pagamento por Pix,
          cartão ou boleto.
        </p>

        <Link to='/comprar' className='pf-btn pf-btn-primary'>
          <IconeCarrinho tamanho={16} /> Começar minha primeira compra
        </Link>
      </div>
    );
  }

  renderOfertas() {
    if (this.state.carregandoPedidos) return null;

    const produtos = this.produtosDisponiveis();

    if (produtos.length === 0) return null;

    return (
      <section className='pf-section'>
        <div className='pf-section-head'>
          <div className='pf-section-headings'>
            <h2 className='pf-section-title'>
              Produtos contratados pela comissão
            </h2>
            <p className='pf-section-sub'>
              Disponíveis para a sua adesão: você define a quantidade e a forma
              de pagamento.
            </p>
          </div>

          <Link to='/comprar' className='pf-link'>
            Ver todos os produtos
          </Link>
        </div>

        <div className='pf-card pf-card-destaque'>
          <div className='pf-card-head'>
            <h3 className='pf-card-title'>Disponíveis para adesão</h3>
            <span className='pf-card-note'>Valores por unidade</span>
          </div>

          <div className='pf-tr pf-tr-oferta pf-thead'>
            <div>Produto</div>
            <div className='pf-cell-categoria'>Categoria</div>
            <div className='pf-cell-value'>Valor</div>
            <div />
          </div>

          <div className='pf-tbody'>
            {produtos.slice(0, 6).map((produto) => {
              const chave = `disponivel-${produto.id}`;
              return (
              <div className='pf-linha' key={chave}>
              <div className='pf-tr pf-tr-oferta'>
                <div className='pf-item'>
                  <MiniaturaProduto
                    produto={{ nome: produto.nome, fotos: produto.fotos }}
                    tamanho={58}
                    onClick={() => this.abrirGaleria(produto.nome)}
                  />
                  <div className='pf-item-label'>{produto.nome}</div>
                  {this.renderBotaoDetalhe(chave)}
                </div>

                <div className='pf-cell-categoria'>
                  <div className='pf-cell-label'>Categoria</div>
                  {this.categoriaDoProduto(produto.nome)}
                </div>

                <div className='pf-cell-value'>
                  <div className='pf-cell-label'>Valor por unidade</div>
                  {this.renderValor(produto.preco)}
                </div>

                <div className='pf-cell-action'>
                  <Link to='/comprar' className='pf-btn-row'>
                    <IconeCarrinho tamanho={16} /> Adquirir agora
                  </Link>
                </div>
              </div>

              {this.state.detalheAberto === chave
                ? this.renderDetalhes(produto.nome)
                : null}
              </div>
              );
            })}
          </div>
        </div>
      </section>
    );
  }

  renderPainelCompras() {
    const { carregandoPedidos, erroPedidos } = this.state;
    const resumo = this.resumoDasCompras();
    const temCompras = resumo.itens.length > 0;

    return (
      <section className='pf-section' id='painelCompras'>
        <div className='pf-section-head'>
          <div className='pf-section-headings'>
            <h2 className='pf-section-title'>
              {temCompras ? 'Minhas compras feitas' : 'Minhas compras'}
            </h2>
            <p className='pf-section-sub'>
              {temCompras
                ? `Total das compras: ${this.formatarMoeda(resumo.valorTotal)}`
                : 'Escolha os produtos liberados para a sua turma e finalize o pedido.'}
            </p>
          </div>
        </div>

        {carregandoPedidos ? (
          this.renderCarregando()
        ) : erroPedidos ? (
          <div className='pf-note'>
            <ExclamationCircleOutlined />
            <span>
              Não foi possível carregar as suas compras agora. Atualize a página
              em alguns instantes ou acesse <strong>Meus pedidos</strong> para
              conferir o seu histórico.
            </span>
          </div>
        ) : temCompras ? (
          this.renderTabelaItens(resumo, 'Itens adquiridos', 'Total investido', true)
        ) : (
          this.renderEstadoVazio()
        )}
      </section>
    );
  }

  /** Formando de contrato sem venda avulsa: nao ha compras a exibir. */
  renderPainelSemVenda() {
    const gestor =
      (this.props.contrato.dono && this.props.contrato.dono.nome) || null;

    return (
      <section className='pf-section' id='painelCompras'>
        <div className='pf-section-head'>
          <div className='pf-section-headings'>
            <h2 className='pf-section-title'>Minhas compras</h2>
            <p className='pf-section-sub'>
              Neste contrato os itens não são vendidos individualmente no
              portal.
            </p>
          </div>
        </div>

        <p className='pf-vazio-texto'>
          Os pedidos da sua turma são feitos pela comissão de formatura
          {gestor ? ` ou pelo(a) gestor(a) ${gestor}` : ''}. Você continua
          acompanhando o convite e a personalização por aqui.
        </p>
      </section>
    );
  }

  renderPainelContrato() {
    const resumo = this.resumoDoContrato();

    if (resumo.itens.length === 0) return null;

    return (
      <section className='pf-section' id='painelCompras'>
        <div className='pf-section-head'>
          <div className='pf-section-headings'>
            <h2 className='pf-section-title'>Itens contratados</h2>
            <p className='pf-section-sub'>
              Produtos previstos no contrato da sua turma.
            </p>
          </div>
        </div>

        {this.renderTabelaItens(
          resumo,
          'Itens do contrato',
          'Valor total do contrato',
          false
        )}
      </section>
    );
  }

  /** Sem nenhuma compra, os produtos vem antes do convite a comprar. */
  renderConteudoDoFormando() {
    const temCompras = this.resumoDasCompras().itens.length > 0;

    if (temCompras) {
      return (
        <React.Fragment>
          {this.renderPainelCompras()}
          {this.renderOfertas()}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {this.renderOfertas()}
        {this.renderPainelCompras()}
      </React.Fragment>
    );
  }

  render() {
    if (this.props.contrato.status === 'deletado') {
      return <Redirect to='/deletado' />;
    }

    return (
      <div className='pf-home'>
        {this.renderCabecalho()}

        {this.podeComprar()
          ? this.renderConteudoDoFormando()
          : this.usuarioEhFormando()
          ? this.renderPainelSemVenda()
          : this.renderPainelContrato()}

        <GaleriaProduto
          produto={this.state.produtoNaGaleria}
          onFechar={this.fecharGaleria.bind(this)}
        />

        <Joyride
          steps={this.passosTutorial()}
          continuous={true}
          run={this.state.run}
          scrollToFirstStep={true}
          showProgress={true}
          showSkipButton={true}
          locale={{
            back: 'Voltar',
            close: 'Fechar',
            last: 'Entendi',
            next: 'Próximo',
            skip: 'Pular',
          }}
          styles={{
            options: {
              primaryColor: '#0078d4',
              zIndex: 10000,
            },
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    contrato: state.contrato.especifico,
    formandos: state.formando.todos,
    numeroContrato: state.usuario.numeroContrato,
    itensDisponiveis: state.item.todosDistribuiveis,
  };
};

export default connect(mapStateToProps, {
  enviarEmail,
  descobrirContrato,
  obterFormandosPeloContrato,
  obterItensTipoFTab,
})(Contrato);
